import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ILoginReminder } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder';

@Component({
    selector: 'fi-login-reminder-overview',
    templateUrl: './fi-login-reminder-overview.component.html',
    styleUrl: './fi-login-reminder-overview.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-login-reminder-overview' },
    standalone: false,
})
export class FiLoginReminderOverviewComponent {
    @Input() loginReminder: ILoginReminder;
}
